var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4108_5190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.294 286.118H406.588C412.257 286.118 417.674 283.411 421.074 278.877C449.043 241.588 512 151.738 512 105.412C512 47.2887 464.712 0 406.588 0C348.463 0 301.176 47.2887 301.176 105.412C301.176 147.049 351.007 221.293 375.488 256H331.294C289.776 256 256 289.777 256 331.294C256 372.811 289.776 406.588 331.294 406.588H353.882C374.641 406.588 391.529 423.476 391.529 444.235C391.529 464.994 374.641 481.882 353.882 481.882H136.511C160.96 447.224 210.824 372.939 210.824 331.294C210.824 273.17 163.536 225.882 105.412 225.882C47.2877 225.882 0 273.17 0 331.294C0 377.657 63.0533 467.597 90.9262 504.76C94.3265 509.293 99.7416 512 105.412 512H353.882C391.248 512 421.647 481.601 421.647 444.235C421.647 406.869 391.248 376.471 353.882 376.471H331.294C306.383 376.471 286.118 356.205 286.118 331.294C286.118 306.383 306.383 286.118 331.294 286.118ZM406.588 75.2941C423.195 75.2941 436.706 88.8049 436.706 105.412C436.706 122.019 423.195 135.529 406.588 135.529C389.981 135.529 376.471 122.019 376.471 105.412C376.471 88.8049 389.981 75.2941 406.588 75.2941ZM75.2941 331.294C75.2941 314.687 88.8049 301.176 105.412 301.176C122.019 301.176 135.529 314.687 135.529 331.294C135.529 347.901 122.019 361.412 105.412 361.412C88.8049 361.412 75.2941 347.901 75.2941 331.294Z",
    fill: "#4F46E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4108_5190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ea005ff80ee675a45bbddf51240b642c.svg";
export { ForwardRef as ReactComponent };